import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/how-to-rank-in-ai-overviews")(blogRouteOptions("how-to-rank-in-ai-overviews"));
